import { useEffect, useState } from "react";
import RadarMap from "@/components/RadarMap";

export function RadarMessages({ ville }) {
  const messages = [`Recherche des architectes à ${ville}...`, "Lecture des avis Google...", "Calcul des positions..."];
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % 3), 900);
    return () => clearInterval(t);
  }, []);

  return (
    <p key={i} data-testid="radar-loading-message" className="fade-up mt-4 text-center text-[14px] text-muted">
      {messages[i]}
    </p>
  );
}

// Sweep-only radar in the map slot (Ma fiche relaunch, before any data).
export default function RadarLoading({ ville }) {
  return (
    <div data-testid="radar-loading">
      <div className="-mx-5 md:mx-0">
        <RadarMap intro interactive={false} />
      </div>
      <RadarMessages ville={ville} />
    </div>
  );
}
